import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import PieChartOutlinedIcon from '@material-ui/icons/PieChartOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import RestorePageIcon from '@material-ui/icons/RestorePage';
import SettingsBrightnessIcon from '@material-ui/icons/SettingsBrightness';
import EventIcon from '@material-ui/icons/Event';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import BusinessIcon from '@material-ui/icons/Business';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import Avatar from '@material-ui/core/Avatar';
import Fade from '@material-ui/core/Fade';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useAppContext } from '../../../context/app.state';
import { can } from '../../../utils/helpers';

const useStyles = makeStyles((theme) => ({
  logo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 64,
    background: theme.palette.primary.main,
  },
  avatarSmall: {
    marginTop: theme.spacing(1),
  },
}));

const DrawerMenuList = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { onMenuClick, desktopOpen } = props;

  const appContext = useAppContext();
  const { state } = appContext;

  const menu1List = [
    { name: t('web/main_menu.home'), icon: <HomeOutlinedIcon />, link: '/' },
    {
      name: t('web/main_menu.dashboard'), icon: <PieChartOutlinedIcon />, link: '/plants', permission: 'plants:view',
    },
    // { name: t('web/main_menu.overview'), icon: <AssignmentOutlinedIcon />, link: '/overview' },
    // { name: t('web/main_menu.production'), icon: <BarChartOutlinedIcon />, link: '/production' },
    {
      name: t('web/main_menu.error_tracking'), icon: <HighlightOffIcon />, link: '/errors_tracking', permission: 'error_tracking:view',
    },
    {
      name: t('web/main_menu.repair_data'), icon: <RestorePageIcon />, link: '/repair_data', permission: 'repair:view',
    },
    // {
    //   name: t('web/main_menu.holiday'), icon: <EventIcon />, link: '/holiday', permission: 'holiday:view',
    // },
    // {
    //   name: t('web/main_menu.tariff_rates'), icon: <MonetizationOnIcon />, link: '/tariff_rates', permission: 'tariff_rate:view',
    // },
    // {
    //   name: t('web/main_menu.invoice_issuer'), icon: <OpenInNewIcon />, link: '/invoice_issuers', permission: 'invoice_issuers:view',
    // },
  ].filter(({ permission }) => !permission || can(permission, state));
  const deviceManagementMenuList = [
    {
      name: t('web/main_menu.solar_panel', 'Solar Panel'), icon: <SettingsBrightnessIcon />, link: '/solar_panel', permission: 'solar_panels:view',
    },
    {
      name: t('web/main_menu.brand', 'Brand'), icon: <BusinessIcon />, link: '/brand', permission: 'brands:view',
    },
  ].filter(({ permission }) => !permission || can(permission, state));
  const backendManagementMenuList = [
    {
      name: t('web/main_menu.users'), icon: <PeopleAltOutlinedIcon />, link: '/users', permission: 'users:view',
    },
    {
      name: t('web/main_menu.role_permission'), icon: <VpnKeyOutlinedIcon />, link: '/roles', permission: 'roles:view',
    },
    {
      name: t('web/main_menu.open_api_account'), icon: <VpnKeyOutlinedIcon />, link: '/open_api_account', permission: 'open_api_account:view',
    },
  ].filter(({ permission }) => !permission || can(permission, state));
  const customerManagementList = [
    {
      name: t('web/main_menu.customer.customers', 'Customers'), icon: <BusinessIcon />, link: '/customers', permission: 'customers:view',
    },
    {
      name: t('web/main_menu.customer.users'), icon: <PeopleAltOutlinedIcon />, link: '/customer_users', permission: 'customer_users:view',
    },
    {
      name: t('web/main_menu.customer.role_permission'), icon: <VpnKeyOutlinedIcon />, link: '/customer_roles', permission: 'customer_roles:view',
    },
  ].filter(({ permission }) => !permission || can(permission, state));

  // const financeMenuList = [
  //   {
  //     name: t('web/main_menu.finance.billings'), icon: <AssignmentOutlinedIcon />, link: '/finance_billings', permission: 'finance_billings:view',
  //   },
  //   {
  //     name: t('web/main_menu.finance.pernalties'), icon: <LocalAtmIcon />, link: '/pernalties', permission: 'pernalties:view',
  //   },
  //   {
  //     name: t('web/main_menu.finance.reconcile'), icon: <CheckCircleOutlineOutlinedIcon />, link: '/finance_reconciles', permission: 'finance_reconciles:view',
  //   },
  //   {
  //     name: t('web/main_menu.finance.rebases'), icon: <MonetizationOnIcon />, link: '/finance_rebates', permission: 'finance_rebates:view',
  //   },
  // ].filter(({ permission }) => !permission || can(permission, state));

  const financeMenuList = [];
  const frontendMenuList = [
    {
      name: t('web/main_menu.frontend.news', 'News'), icon: <AnnouncementIcon />, link: '/news', permission: 'news:view',
    },
  ].filter(({ permission }) => !permission || can(permission, state));

  return (
    <div>
      {/* <div className={classes.toolbar} /> */}
      <div className={classes.logo}>
        <Fade in timeout={2000}>
          <img src="/logo.svg" alt="logo" />
        </Fade>
      </div>
      <Divider />
      <List>
        {
          menu1List
            .filter(({ permission }) => !permission || can(permission, state))
            .map((menu, index) => (
              <ListItem button key={index} onClick={() => onMenuClick(menu.link)}>
                <ListItemIcon>{menu.icon}</ListItemIcon>
                <ListItemText primary={menu.name} />
              </ListItem>
            ))
        }
      </List>
      <Divider />
      {
        deviceManagementMenuList.length > 0 && (
          <List
            subheader={(
              <ListSubheader component="div" id="nested-list-subheader">
                {
                  desktopOpen
                    ? t('web/main_menu.header.device_management', 'Device Management')
                    : <Avatar className={classes.avatarSmall}>{t('Device Management').substr(0, 1)}</Avatar>
                }
              </ListSubheader>
            )}
          >
            {
              deviceManagementMenuList
                .map((menu, index) => (
                  <ListItem button key={index} onClick={() => onMenuClick(menu.link)}>
                    <ListItemIcon>{menu.icon}</ListItemIcon>
                    <ListItemText primary={menu.name} />
                  </ListItem>
                ))
            }
          </List>
        )
      }
      <Divider />
      {
        backendManagementMenuList.length > 0 && (
          <List
            subheader={(
              <ListSubheader component="div" id="nested-list-subheader">
                {
                  desktopOpen
                    ? t('web/main_menu.header.management')
                    : <Avatar className={classes.avatarSmall}>{t('web/main_menu.header.management').substr(0, 1)}</Avatar>
                }
              </ListSubheader>
            )}
          >
            {
              backendManagementMenuList
                .map((menu, index) => (
                  <ListItem button key={index} onClick={() => onMenuClick(menu.link)}>
                    <ListItemIcon>{menu.icon}</ListItemIcon>
                    <ListItemText primary={menu.name} />
                  </ListItem>
                ))
            }
          </List>
        )
      }
      <Divider />
      {
        financeMenuList.length > 0 && (
          <List
            subheader={(
              <ListSubheader component="div" id="nested-list-subheader">
                {
                  desktopOpen
                    ? t('web/main_menu.header.finance', 'Frontend Management')
                    : <Avatar className={classes.avatarSmall}>{t('web/main_menu.header.finance', 'Frontend Management').substr(0, 1)}</Avatar>
                }
              </ListSubheader>
            )}
          >
            {
              financeMenuList
                .map((menu, index) => (
                  <ListItem button key={index} onClick={() => onMenuClick(menu.link)}>
                    <ListItemIcon>{menu.icon}</ListItemIcon>
                    <ListItemText primary={menu.name} />
                  </ListItem>
                ))
            }
          </List>
        )
      }
      <Divider />
      {
        customerManagementList.length > 0 && (
          <List
            subheader={(
              <ListSubheader component="div">
                {
                  desktopOpen
                    ? t('web/main_menu.header.customer.management')
                    : <Avatar className={classes.avatarSmall}>{t('web/main_menu.header.customer.management').substr(0, 1)}</Avatar>
                }
              </ListSubheader>
            )}
          >
            {
              customerManagementList
                .map((menu, index) => (
                  <ListItem button key={index} onClick={() => onMenuClick(menu.link)}>
                    <ListItemIcon>{menu.icon}</ListItemIcon>
                    <ListItemText primary={menu.name} />
                  </ListItem>
                ))
            }
          </List>
        )
      }
      <Divider />
      {
        frontendMenuList.length > 0 && (
          <List
            subheader={(
              <ListSubheader component="div" id="nested-list-subheader">
                {
                  desktopOpen
                    ? t('web/main_menu.header.frontend')
                    : <Avatar className={classes.avatarSmall}>{t('web/main_menu.header.frontend').substr(0, 1)}</Avatar>
                }
              </ListSubheader>
            )}
          >
            {
              frontendMenuList
                .map((menu, index) => (
                  <ListItem button key={index} onClick={() => onMenuClick(menu.link)}>
                    <ListItemIcon>{menu.icon}</ListItemIcon>
                    <ListItemText primary={menu.name} />
                  </ListItem>
                ))
            }
          </List>
        )
      }
    </div>
  );
};

DrawerMenuList.defaultProps = {
  onMenuClick: () => { },
};
DrawerMenuList.propTypes = {
  onMenuClick: PropTypes.func,
  desktopOpen: PropTypes.bool.isRequired,
};

export default DrawerMenuList;
